module.exports = __webpack_public_path__ + "img/Декларация_о_соответствии_Песок_дробленный_1,2_класса_page-0001.958846c7.jpg";